import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 text-slate-400 py-12 border-t border-navy-900 text-center" data-id="element-204">
      <div className="container mx-auto px-4" data-id="element-205">
        <h3 className="text-2xl font-bold text-white mb-4" data-id="element-206">
          Reinicia Tus Finanzas
        </h3>
        <p className="text-sm mb-6 max-w-2xl mx-auto" data-id="element-207">
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
        <p className="text-sm mb-2" data-id="element-208">
          Los resultados pueden variar según la aplicación de cada usuario. El
          éxito en los negocios depende de múltiples factores.
        </p>
        <p className="text-sm" data-id="element-209">
          &copy; {new Date().getFullYear()} Reinicia Tus Finanzas. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}